<template>
  <div>
    <div class="fyd-body">
      <div>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="2" :md="2" :lg="3" >
            <div class="library_left_side" >
              <h4  class="cation">分类列表</h4>
              <div v-for="(item,index) in navArray" :key="index">
                <div
                  :class="['library_nav_item', (index==currNav)?'main_nav_chg_bgc':'']"
                  @click="switchNav(index)"
                >
                  <p style="line-height:38px;margin-top:10px">{{item}}</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="21" :md="21" :lg="21" class="library_right_side" style="padding:0 !important;">
            <div class="library_right_side">
              <!-- <CPList v-if="currNav==0" @gotoBook="gotoBookHandle"></CPList> -->
              <publishBook v-if="currNav==0" @gotoBook="gotoBookHandle"></publishBook> 
              <bookNewList v-else-if="currNav==1" :editCPId="editCPId" :editCPName="editCPName"></bookNewList>   
              <albumNewList v-else-if="currNav==2"></albumNewList>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import publishBook from "./components/publishBook";
import bookNewList from "./components/bookNewList";
import albumNewList from "./components/albumNewList";
export default {
  name: "library",
  components: { publishBook,bookNewList, albumNewList },
  data() {
    return {
      navArray: ["内容提供商", "图书", "专辑"],
      currNav: 0,
      editCPId: null,
      editCPName: "",
    };
  },
  props: {},
  created() {
    let temp = sessionStorage.getItem("libraryIndex");
    if (temp != null) {
      this.currNav = temp;
    }
  },
  computed: {},
  filters: {},
  mounted() {},
  watch: {
    currNav(newVal, oldVal) {
      let temp = sessionStorage.getItem("libraryIndex");
      if (temp != null) {
        sessionStorage.removeItem("libraryIndex");
      }
      sessionStorage.setItem("libraryIndex", newVal);
    }
  },
  methods: {
    switchNav(index) {
      this.currNav = index;
      this.editCPId = null;
      this.editCPName = "";
    },
    gotoBookHandle(param) {
      this.currNav = 1;
      this.editCPId = param.id;
      this.editCPName = param.name;
    }
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";

</style>


// WEBPACK FOOTER //
// receiveBook.vue?9d1f33ca